import BaseScreen from './_base';

export default function MyTeamScreen() {
  return <BaseScreen title="My Team" description="Team management." />;
}
